import { useMemo, useEffect } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { isEqual } from 'lodash'

import driverMapApi from 'apis/disApi/driverMapApi'

const driverHeartBeatKey = {
	prefixKey: ['getDriverHeartBeat'],
	driverHeartBeat: (userId, from, to, showHistory) => [
		...driverHeartBeatKey.prefixKey,
		userId,
		from,
		to,
		showHistory,
	],
}
export const useDriverHeartBeat = ({
	userId,
	fromDate,
	toDate,
	showHistory,
	allHeartBeatQueryRef,
}) => {
	const environment = useSelector((state) => state.environment)
	const queryClient = useQueryClient()
	const queryKey = useMemo(() => {
		if (!userId) return null
		return driverHeartBeatKey.driverHeartBeat(userId, fromDate, toDate, showHistory)
	}, [userId, fromDate, toDate, showHistory])

	useEffect(() => {
		if (!allHeartBeatQueryRef) return

		if (!queryKey) {
			if (allHeartBeatQueryRef.current != null) {
				allHeartBeatQueryRef.current = null
			}
			return
		}

		if (isEqual(allHeartBeatQueryRef.current, queryKey)) return

		allHeartBeatQueryRef.current = queryKey
		queryClient.invalidateQueries({ queryKey, exact: true })
	}, [queryKey, queryClient, allHeartBeatQueryRef])

	const { data, isFetching } = useQuery({
		queryKey: queryKey,
		queryFn: () =>
			driverMapApi.getDriverHeartBeat({
				user_id: userId,
				after: fromDate,
				before: toDate,
				showHistory,
				token: environment?.apiToken,
			}),
		enabled: !!queryKey && !!environment?.apiToken, // Only fetch if enabled
	})

	return {
		allDriverHeartBeat: data?.data || [],
		isLoadingDriverHeartBeat: !userId ? false : isFetching,
	}
}
